export default __webpack_public_path__ + "static/media/nci.png";